// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  InvoiceLifecycleListingFilter,
  getInvoiceLifecycleListing,
} from '@/billing/api/get-invoice-lifecycle-listing';
import { TWO_MINUTES_MS } from '@/utilities/time-constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

// Fetches one page of per-invoice detail rows for the billing lifecycle
// report. Server owns pagination, sort, and search — the caller passes
// `page`, `pageSize`, `sortBy`, `sortOrder`, and `search`, and the hook
// returns the current page of rows plus the filtered `totalCount` so the
// pagination footer and the empty-state check both use the same authoritative
// value.
export function useInvoiceLifecycleListing(
  filter: InvoiceLifecycleListingFilter
) {
  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: [
      'invoice-lifecycle',
      'list',
      filter.windowDays ?? null,
      filter.customerKeys ?? [],
      filter.projectKeys ?? [],
      filter.search ?? '',
      filter.page ?? 1,
      filter.pageSize ?? null,
      filter.sortBy ?? '',
      filter.sortOrder ?? '',
    ],
    queryFn: () => getInvoiceLifecycleListing(filter),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
    refetchInterval: TWO_MINUTES_MS,
  });

  return {
    rows: data?.rows ?? null,
    totalCount: data?.totalCount ?? null,
    isLoading,
    isFetching,
    isError,
  };
}
